import { RemoteAdvertisingDelete } from 'data/usecases';
import { AdvertisingDeleteUseCaseInterface } from 'domain/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeAdvertisingDelete = (): AdvertisingDeleteUseCaseInterface =>
  new RemoteAdvertisingDelete(makeApiUrlEntities(), makeAxiosHttpClient());
